/**
 * Copyright (c) 2026 上海安能聚创供应链管理有限公司.
 * All rights reserved.
 * 公司内部代码，未经书面授权，不得以任何形式复制、传播或用于与本项目无关的其他用途。
 */
import { message } from 'antd';
import request from '@aned/request';

const DataSourceApiUrl = {
  hbase: '/api/route/hbase/getDeliveryReceiptMessage',
  druid: '/api/route/statistic',
  druid2: '/api/routeSr/selectStatistic',
  dorisdb: '/api/forecastdoris/statistic',
};

export async function selectCMlist(params) {
  return request('/api/route/selectCMList', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}
export async function getMonthData() {
  return request('/api/report/traffic/month', {
    method: 'post',
    data: [],
  });
}

export async function getCompletionRate() {
  return request('/api/report/completionRate', {
    method: 'post',
    data: [],
  });
}

export async function getCompletionRateMonth() {
  return request('/api/report/completionRateMonth', {
    method: 'post',
    data: [],
  });
}

export async function getCommon(params, datadb = 'druid') {
  params.queryType = 'groupBy';
  return request(DataSourceApiUrl[datadb], {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    method: 'post',
    body: params,
    reqType: 'json',
  });
}

export async function getTopN(params, datadb = 'druid') {
  params.queryType = 'topN';
  return request(DataSourceApiUrl[datadb], {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    method: 'post',
    body: params,
    reqType: 'json',
  });
}

export async function updateFile(params) {
  return request('/api/blame/aggregate/pageFileToUep', {
    // headers: { 'Content-Type': 'multipart/form-data' },
    method: 'upload',
    body: params,
  });
}

export async function getTimestampData(params, datadb = 'druid', url = '') {
  params.queryType = 'timeSeries';
  const apiUrl = url || DataSourceApiUrl[datadb];
  try {
    const response = await request(apiUrl, {
      method: 'post',
      body: params,
      reqType: 'json',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
    });

    if (response && response.code === 1 && response?.data) {
      let list;
      if (typeof response.data === 'string') {
        try {
          list = JSON.parse(response.data);
        } catch (error) {
          return [];
        }
      } else {
        list = response.data;
      }
      const newList = list?.map((item) => {
        return {
          ...item,
          ...item.result,
          time: item.timestamp,
        };
      });
      return newList;
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
}

export async function getScanDateList(params, datadb = 'druid') {
  params.queryType = 'scan';
  return request(DataSourceApiUrl[datadb], {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    method: 'post',
    body: params,
    reqType: 'json',
  });
}

export async function getDorisData(params, datadb = 'dorisdb') {
  return request(DataSourceApiUrl[datadb], {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    method: 'post',
    body: params,
    reqType: 'json',
  });
}

export async function getScanDate(params, datadb = 'druid', config) {
  params.queryType = 'scan';
  const result = await request(DataSourceApiUrl[datadb], {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    method: 'post',
    body: params,
    reqType: 'json',
    ...config,
  });

  if (result && result.code === 1) {
    const data = JSON.parse(result.data || null);
    if (data.error) {
      message.error({ title: '查询出现错误', description: data.data });
      return [];
    }
    const tempData = [];
    data.forEach((item) => tempData.push(...item.events));
    return tempData;
  }
  return [];
}

// selectStatistic 过滤字段 key：产品类型
const FILTER_KEY_PRODUCT_TYPE = 'productType';
// 产品类型枚举：整车（默认从统计中排除）
const PRODUCT_TYPE_WHOLE_VEHICLE = '整车';

export function excludeVehicle(params) {
  const findResult = params.andFilters?.find((item) => {
    return item.key === 'scanType' && (item.value === '录单' || item.value === '签收');
  });
  if (!findResult) {
    params.notFilters = params.notFilters || [];
    params.notFilters.push({ key: FILTER_KEY_PRODUCT_TYPE, value: PRODUCT_TYPE_WHOLE_VEHICLE });
  }

  return params;
}

/**
 * andFilters 已含 productType 正向过滤时，移除 notFilters 中的 productType，
 * 避免正向筛产品类型与反向排除整车叠加冲突；andFilters 未含 productType 时不做改动
 * @param {object} params selectStatistic 查询参数
 * @returns {object} 处理后的查询参数
 */
function removeProductTypeNotFilter(params) {
  const hasProductType = params.andFilters?.some((item) => item.key === FILTER_KEY_PRODUCT_TYPE);
  if (hasProductType) {
    params.notFilters = (params.notFilters || []).filter(
      (item) => item.key !== FILTER_KEY_PRODUCT_TYPE,
    );
  }
  return params;
}

//查询通用数据接口
//此接口不根据时间进行分组
export async function getData(params, datadb = 'druid', config) {
  params.queryType = params.queryType || 'groupBy';
  const response = await request(DataSourceApiUrl[datadb], {
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    body: params,
    reqType: 'json',
    ...config,
  });
  if (response && response.code === 1 && response?.data) {
    let list;
    if (typeof response.data === 'string') {
      try {
        list = JSON.parse(response.data);
      } catch (error) {
        return [];
      }
    } else {
      list = response.data;
    }

    const newList = list?.map((item) => {
      return {
        ...item,
        ...item.event,
        time: item.timestamp,
      };
    });
    const { ratio, yField } = params;
    let total = 0;

    //判断是否需要进行百分比计算
    if (ratio) {
      newList.forEach((element) => {
        total = total + element[yField];
      });
    }

    const newArray = newList.map((item) => {
      if (ratio) {
        item[yField] = Math.round((item[yField] / total) * 10000) / 100.0;
      }
      return item;
    });

    let destinationProvinceArea;
    if (params.andFilters) {
      params.andFilters.map((item) => {
        if (item.key === 'destinationProvinceArea') {
          destinationProvinceArea = item.value;
        }
      });
    }
    // 剔除 目的数据中和始发数据重复的一项
    if (destinationProvinceArea) {
      let index = newArray.findIndex(
        (item) => item.destinationProvinceArea === item.originProvinceArea,
      );
      if (index && index != -1) {
        newArray.splice(index, 1);
      }
    }

    return newArray;
  } else {
    return [];
  }
}

export async function getData_Vehicle(params, datadb, config) {
  params = excludeVehicle(params);
  return getData(params, (datadb = 'druid'), config);
}

export async function getData_Vehicle2(params, config = {}, datadb = 'druid') {
  // console.log('%c [ params, config, datadb ]-230', 'font-size:13px; background:pink; color:#bf2c9f;', params, config, datadb)
  params = removeProductTypeNotFilter(excludeVehicle(params));
  return getData(params, datadb, config);
}

// 并发分组查询通用数据接口
export async function getDataConcurrent(params, datadb = 'druid', config = {}) {
  const concurrentCount = params.length;
  const promiseAll = [];
  for (let i = 0; i < concurrentCount; i++) {
    params[i].queryType = 'groupBy';
    const promise = request(DataSourceApiUrl[datadb], {
      method: 'post',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      body: params[i],
      reqType: 'json',
      ...config,
    });

    promiseAll.push(promise);
  }

  let result = await Promise.all(promiseAll);
  result = result.map((response) => {
    if (response && response.code === 1 && response.data) {
      let list;
      if (typeof response.data === 'string') {
        try {
          list = JSON.parse(response.data);
        } catch (error) {
          return [];
        }
      } else {
        list = response.data;
      }
      return (
        list?.map((item) => {
          return {
            ...item,
            ...item.event,
            time: item.timestamp,
          };
        }) || []
      );
    }
    return [];
  });
  return result;
}

export async function getDataConcurrent_Vehicle(params, datadb, config) {
  params = params?.map((param) => excludeVehicle(param));
  return getDataConcurrent(params, (datadb = 'druid'), config);
}

export async function getDataConcurrent_Vehicle2(params, config, datadb = 'druid') {
  // console.log('%c [ params, config, datadb ]-274', 'font-size:13px; background:pink; color:#bf2c9f;', params, config, datadb)
  params = params?.map((param) => removeProductTypeNotFilter(excludeVehicle(param)));
  return getDataConcurrent(params, datadb, config);
}

/**
 * 根据段重查询OD商品的重量
 *
 * @param params 查询参数
 * @returns Promise<any> 返回查询结果
 */
export async function ODGoodsWeightBySectionWeight(params) {
  return request('/api/route/od/ODGoodsWeightBySectionWeight', {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    method: 'post',
    body: params,
    reqType: 'json',
  });
}
